export const environment = {
    apiUrl: 'https://api-stg.kgfitness.in/'
};
